<template>
	<div 
	class="form-group" 
	:class="formGroupClass">
		<form-label 
		v-if="label" 
		:for="id">
			{{label}}
		</form-label>
		
		<v-date-picker 
		:attributes="attrs"
		:popover="{ visibility: 'click' }"
		:value="date" 
		:mode="mode"
		@input="emit" 
		:min-date='fromToday ? new Date() : null'
		:minute-increment="5"
		:is24hr="true"
		clearable>
			<template v-slot="{ inputValue, inputEvents }">
			    
				<div class="input-group input-group-date input-group-merge">

					<div class="input-group-text border-0">
						<span class="bi bi-calendar"></span>
					</div>
					
					<input class="form-control ps-0"
				      :value="inputValue"
				      v-on="inputEvents"
				    />

				</div>

			</template>

			<template v-slot:footer>
				<slot name="footer"></slot>
			</template>

		</v-date-picker>

		<form-errors v-bind="{errors}" />

	</div>
</template>

<script>
	export default {

		props: {

			id: {
				type: String,
				default() {
					return `input-date-${this._uid}`
				},
			},

			formGroupClass: {
				type: [String, Array],
				default: ''
			},

			mode: {
				type: String,
				default: 'date'
			},

			fromToday: {
				type: Boolean,
				default: false
			},

			errors: {
				type: String,
				default: ''
			},

			value: [Date, String, Object],
			label: String,
			sublabel: String,
		},

		data() {
			return {
				props: {
					class: "form-control form-control-prepended"
				},
				attrs: [
					{
						key: 'today',
						dates: new Date(),
						highlight:'blue'
					},
				],
			}
		},

		computed: {

			val() {
				return this.value
			},

			date() {
				if(!this.val)
					return null;

				return (this.val instanceof Date) 
				? this.val 
				: new Date(this.val);
			}
		},

		methods: {

			emit(value) {
				var date = value 
				? moment(value).format('YYYY-MM-DD')
				: ''
				
				this.$emit('input', date)
			}

		}
	}
</script>